import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { forwardRef } from "react"
import styled from "styled-components"

const Container = styled(Box)`
  align-items: center;
  display: flex;
  font-size: 12px;
  line-height: 1.2;
  position: relative;
  ${(props) => props.theme.radioButton.label}
`
const Input = styled.input.attrs({ type: "radio" })`
  appearance: none;
  margin-right: 15px;
  position: relative;
  border: 0;
  &:focus {
    outline: none;
  }
  &:before {
    cursor: pointer;
    display: ${(props) => (props.checked ? "block" : "none")};
    ${(props) => props.theme.radioButton.before}
  }
  &:after {
    background-color: ${(props) => props.theme.colors.white};
    border-radius: 50%;
    content: "";
    cursor: pointer;
    height: 22px;
    left: -4px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 22px;
    z-index: 1;
    ${(props) => props.theme.radioButton.after.base}
    ${(props) => props.checked && props.theme.radioButton.after.checked}
  }
`
const Text = styled.span`
  flex: 1;
  position: relative;
  top: 2px;
`

const Checkbox = forwardRef(
  ({ checked, children, label, ...props }, ref) => (
    <Container>
      <Input checked={checked} ref={ref} {...props} />
      <Text>{children || label}</Text>
    </Container>
  )
)

Checkbox.propTypes = {
  checked: PropTypes.bool,
  children: PropTypes.element,
  label: PropTypes.string,
  radio: PropTypes.bool,
}

Checkbox.displayName = "Checkbox"

export default Checkbox
